module.exports = __webpack_public_path__ + "img/ysyz.d2a5ba60.png";